/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MessagesChatExistingChat } from '../models/MessagesChatExistingChat';
import type { MessagesChatNewChat } from '../models/MessagesChatNewChat';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ChatApiService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Get all chats for an application (Authorised Roles: SuperUser, ApplicationAdministrator)
     * @param applicationId
     * @returns MessagesChatExistingChat OK
     * @throws ApiError
     */
    public getChatApiGetChat(
        applicationId: number,
    ): CancelablePromise<Array<MessagesChatExistingChat>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/rest/chat/{applicationId}',
            path: {
                'applicationId': applicationId,
            },
        });
    }

    /**
     * Add a new chat on an application (Authorised Roles: SuperUser, ApplicationAdministrator)
     * @param applicationId
     * @param requestBody
     * @returns MessagesChatExistingChat OK
     * @throws ApiError
     */
    public putChatApiAddChat(
        applicationId: number,
        requestBody?: MessagesChatNewChat,
    ): CancelablePromise<Array<MessagesChatExistingChat>> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/rest/chat/{applicationId}',
            path: {
                'applicationId': applicationId,
            },
            body: requestBody,
            mediaType: 'application/json-patch+json',
        });
    }

    /**
     * Update a chat
     * @param applicationId
     * @param requestBody
     * @returns MessagesChatExistingChat OK
     * @throws ApiError
     */
    public postChatApiPostChat(
        applicationId: number,
        requestBody?: MessagesChatExistingChat,
    ): CancelablePromise<MessagesChatExistingChat> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/rest/chat/{applicationId}',
            path: {
                'applicationId': applicationId,
            },
            body: requestBody,
            mediaType: 'application/json-patch+json',
        });
    }

    /**
     * Get a single chat (Authorised Roles: SuperUser, ApplicationAdministrator)
     * @param applicationId
     * @param chatId
     * @returns MessagesChatExistingChat OK
     * @throws ApiError
     */
    public getChatApiGetChatItem(
        applicationId: number,
        chatId: number,
    ): CancelablePromise<MessagesChatExistingChat> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/rest/chat/{applicationId}/{chatId}',
            path: {
                'applicationId': applicationId,
                'chatId': chatId,
            },
        });
    }

}
